import React from 'react';

function NoMatch(props) {
  return (
    <div className="noMatch">
     {/* 404 gif image goes here via CSS background url */}
    </div>
  )
}

export default NoMatch;